/**
 * Shared layout math for RICHTEXT card objects, used by BOTH the renderer
 * (`RichTextCardObject`) and the editor (`RichTextCardObjectEditor`) so the two
 * cannot drift — the WYSIWYG guarantee. See the text-rendering & typography
 * LLD §6.1 (Phase 0 / issue #574).
 */

/**
 * Resolve the RICHTEXT box width in px from the stored `width` percentage and
 * the card's rendered width. A falsy `widthPercent` (`undefined` or `0`) or a
 * missing card width means "no width constraint".
 */
export function resolveRichTextWidthPx(
  widthPercent: number | undefined,
  cardWidthPx: number | undefined,
): number | undefined {
  return widthPercent && cardWidthPx
    ? (widthPercent / 100) * cardWidthPx
    : undefined;
}

/**
 * Wrapping is OPT-IN per object via an explicit `wrap` flag (default off).
 * Every existing object has no flag → single-line `nowrap`, exactly as today,
 * so nothing existing or already-sent changes. Only objects an artist turns on
 * will wrap (within their width box). This is the minimal, safe seed of the
 * LLD's future `layoutMode`.
 */
export function richTextWhiteSpace(
  wrap: boolean | undefined,
): "normal" | "nowrap" {
  return wrap ? "normal" : "nowrap";
}
